/*!
 * Copyright (c) 2022 Digital Bazaar, Inc. All rights reserved.
 */
export const name = 'eddsa-2022';
